function isObjectLike(value) {
  return value != null && typeof value == "object";
}

var isObjectLike_1 = isObjectLike;
export { isObjectLike_1 as i };